<mat-expansion-panel class="u-margin-bottom-20">
  <mat-expansion-panel-header>
    <mat-panel-title>Maximum Speed/Power</mat-panel-title>
  </mat-expansion-panel-header>

  <div class="maximum-speed-power-container" *ngIf="featureEnabled; else featureDisabledTemplate">
    <div *ngIf="(apiStatus$ | async) === 'loading'; then loadingTemplate; else contentTemplate"></div>
  </div>

  <ng-template #contentTemplate>
    <form [formGroup]="maximumSpeedPowerForm" (ngSubmit)="onSave()">

      <!-- Speed Section -->
      <mat-card class="section-card mat-elevation-z0">
        <mat-card-header>
          <mat-card-title>
            <mat-icon class="section-icon">speed</mat-icon>
            Speed
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="input-row">
            <mat-form-field appearance="outline" class="input-field">
              <mat-label>Duration (seconds)</mat-label>
              <input matInput
                    type="number"
                    formControlName="speedDuration">
              <mat-icon matSuffix>timer</mat-icon>
              <mat-error *ngIf="maximumSpeedPowerForm.get('speedDuration')?.invalid">
                {{getErrorMessage('speedDuration')}}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-field">
              <mat-label>Distance (meters)</mat-label>
              <input matInput
                    type="number"
                    formControlName="speedDistance">
              <mat-icon matSuffix>straighten</mat-icon>
              <mat-error *ngIf="maximumSpeedPowerForm.get('speedDistance')?.invalid">
                {{getErrorMessage('speedDistance')}}
              </mat-error>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Power Section -->
      <mat-card class="section-card mat-elevation-z0">
        <mat-card-header>
          <mat-card-title>
            <mat-icon class="section-icon">flash_on</mat-icon>
            Power
          </mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="input-row">
            <mat-form-field appearance="outline" class="input-field">
              <mat-label>Duration (seconds)</mat-label>
              <input matInput
                    type="number"
                    formControlName="powerDuration">
              <mat-icon matSuffix>timer</mat-icon>
              <mat-error *ngIf="maximumSpeedPowerForm.get('powerDuration')?.invalid">
                {{getErrorMessage('powerDuration')}}
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="input-field">
              <mat-label>Power (watts)</mat-label>
              <input matInput
                    type="number"
                    formControlName="powerWatts">
              <mat-icon matSuffix>bolt</mat-icon>
              <mat-error *ngIf="maximumSpeedPowerForm.get('powerWatts')?.invalid">
                {{getErrorMessage('powerWatts')}}
              </mat-error>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <div class="save-button-container">
        <button
          type="submit"
          class="percent u-margin-top-50"
          mat-raised-button
          color="primary"
          [disabled]="(apiStatus$ | async) === 'saving' || maximumSpeedPowerForm.invalid">
          Save
        </button>
      </div>
    </form>
  </ng-template>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <mat-spinner></mat-spinner>
      <p>Loading metric settings...</p>
    </div>
  </ng-template>

  <ng-template #featureDisabledTemplate>
    <div class="metric_settings__try-for-free-container u-margin-top-20 o-flex o-flex--align-items-center o-flex--justify-center u-border-radius border-color u-padding-16 tile-color-background">
      <button color="primary" mat-raised-button (click)="purchaseMetric()">{{tryForFreeText()}}</button>
    </div>
  </ng-template>

</mat-expansion-panel>
